"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.CreateProfileRequestAccessEnum = void 0;
const axios_1 = require("axios");
const common_1 = require("./common");
const base_1 = require("./base");
var CreateProfileRequestAccessEnum;
(function (CreateProfileRequestAccessEnum) {
    CreateProfileRequestAccessEnum["Owner"] = "owner";
    CreateProfileRequestAccessEnum["Customer"] = "customer";
})(CreateProfileRequestAccessEnum = exports.CreateProfileRequestAccessEnum || (exports.CreateProfileRequestAccessEnum = {}));
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        featureFlagsControllerGetFeatureFlags: async (searchFeatureFlagsRequest, options = {}) => {
            (0, common_1.assertParamExists)('featureFlagsControllerGetFeatureFlags', 'searchFeatureFlagsRequest', searchFeatureFlagsRequest);
            const localVarPath = `/feature-flags/search`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(searchFeatureFlagsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        healthCheckControllerGetHealthCheck: async (options = {}) => {
            const localVarPath = `/hc`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        healthCheckControllerGetHealthZCheck: async (options = {}) => {
            const localVarPath = `/healthz`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        healthCheckControllerPing: async (options = {}) => {
            const localVarPath = `/ping`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        profilesControllerCreateProfileEntry: async (type, createProfileRequest, options = {}) => {
            (0, common_1.assertParamExists)('profilesControllerCreateProfileEntry', 'type', type);
            (0, common_1.assertParamExists)('profilesControllerCreateProfileEntry', 'createProfileRequest', createProfileRequest);
            const localVarPath = `/profiles/{type}`.replace(`{${'type'}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createProfileRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        profilesControllerDeleteProfileEntry: async (type, id, options = {}) => {
            (0, common_1.assertParamExists)('profilesControllerDeleteProfileEntry', 'type', type);
            (0, common_1.assertParamExists)('profilesControllerDeleteProfileEntry', 'id', id);
            const localVarPath = `/profiles/{type}/{id}`
                .replace(`{${'type'}}`, encodeURIComponent(String(type)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        profilesControllerGetProfileEntries: async (type, options = {}) => {
            (0, common_1.assertParamExists)('profilesControllerGetProfileEntries', 'type', type);
            const localVarPath = `/profiles/{type}`.replace(`{${'type'}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        async featureFlagsControllerGetFeatureFlags(searchFeatureFlagsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerGetFeatureFlags(searchFeatureFlagsRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async healthCheckControllerGetHealthCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckControllerGetHealthCheck(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async healthCheckControllerGetHealthZCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckControllerGetHealthZCheck(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async healthCheckControllerPing(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckControllerPing(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async profilesControllerCreateProfileEntry(type, createProfileRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesControllerCreateProfileEntry(type, createProfileRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async profilesControllerDeleteProfileEntry(type, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesControllerDeleteProfileEntry(type, id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async profilesControllerGetProfileEntries(type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilesControllerGetProfileEntries(type, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        featureFlagsControllerGetFeatureFlags(searchFeatureFlagsRequest, options) {
            return localVarFp
                .featureFlagsControllerGetFeatureFlags(searchFeatureFlagsRequest, options)
                .then((request) => request(axios, basePath));
        },
        healthCheckControllerGetHealthCheck(options) {
            return localVarFp.healthCheckControllerGetHealthCheck(options).then((request) => request(axios, basePath));
        },
        healthCheckControllerGetHealthZCheck(options) {
            return localVarFp.healthCheckControllerGetHealthZCheck(options).then((request) => request(axios, basePath));
        },
        healthCheckControllerPing(options) {
            return localVarFp.healthCheckControllerPing(options).then((request) => request(axios, basePath));
        },
        profilesControllerCreateProfileEntry(type, createProfileRequest, options) {
            return localVarFp
                .profilesControllerCreateProfileEntry(type, createProfileRequest, options)
                .then((request) => request(axios, basePath));
        },
        profilesControllerDeleteProfileEntry(type, id, options) {
            return localVarFp
                .profilesControllerDeleteProfileEntry(type, id, options)
                .then((request) => request(axios, basePath));
        },
        profilesControllerGetProfileEntries(type, options) {
            return localVarFp
                .profilesControllerGetProfileEntries(type, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
class DefaultApi extends base_1.BaseAPI {
    featureFlagsControllerGetFeatureFlags(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .featureFlagsControllerGetFeatureFlags(requestParameters.searchFeatureFlagsRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    healthCheckControllerGetHealthCheck(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .healthCheckControllerGetHealthCheck(options)
            .then((request) => request(this.axios, this.basePath));
    }
    healthCheckControllerGetHealthZCheck(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .healthCheckControllerGetHealthZCheck(options)
            .then((request) => request(this.axios, this.basePath));
    }
    healthCheckControllerPing(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .healthCheckControllerPing(options)
            .then((request) => request(this.axios, this.basePath));
    }
    profilesControllerCreateProfileEntry(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .profilesControllerCreateProfileEntry(requestParameters.type, requestParameters.createProfileRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    profilesControllerDeleteProfileEntry(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .profilesControllerDeleteProfileEntry(requestParameters.type, requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    profilesControllerGetProfileEntries(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .profilesControllerGetProfileEntries(requestParameters.type, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map